import "./index.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SubHeaderBox from "../../components/SubHeaderBox";
import ProdSubBox from "../../components/SubcategoryBox/";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import ProdTravelTable from "./Table";

const ProdTravelContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const [selectedMethod, setSelectedMethod] = useState("manual"); // 'manual' or 'invoice'
  const shouldShowTable = isPDFMode || showTable;

  const handleMethodChange = (method) => {
    setSelectedMethod(method);
  };

  return (
    <div className="prod-component-contents">
      {/* Method Selection Warning */}
      <SubHeaderBox
        subTitle={t("METHOD_SELECTION_WARNING")}
        isNormal={true}
        number={"14"}
        icon={null}
      />

      {/* Method Selection Buttons */}
      <div className="method-selection">
        <button
          className={`method-button ${
            selectedMethod === "invoice" ? "active" : ""
          }`}
          onClick={() => handleMethodChange("invoice")}
        >
          {t("INVOICE_METHOD")} (Flow 14.1)
        </button>
        <button
          className={`method-button ${
            selectedMethod === "manual" ? "active" : ""
          }`}
          onClick={() => handleMethodChange("manual")}
        >
          {t("EMISSION_FACTOR_METHOD")} (Flow 14.2)
        </button>
      </div>

      {/* Flow 14.1: Invoice Method */}
      {selectedMethod === "invoice" && (
        <div className="invoice-method-container">
          <ProdSubBox
            title={t("IF_YOU_HAVE_INVOICES")}
            desc={t("INVOICE_METHOD_DESC")}
          />
          {shouldShowTable && (
            <TableLoadingWrapper
              tableId={`prod-travel-invoice-${productId}`}
              minLoadTime={3000}
              maxLoadTime={20000}
              className="invoice-table-wrapper"
            >
              <ProdTravelTable
                productId={productId}
                method="invoice"
                key={`invoice-${productId}`}
              />
            </TableLoadingWrapper>
          )}
          <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
        </div>
      )}

      {/* Flow 14.2: Emission Factor Method */}
      {selectedMethod === "manual" && (
        <div className="manual-method-container">
          <ProdSubBox
            title={t("IF_YOU_HAVE_SPECIFIC_EMISSION_FACTOR_DATA")}
            desc={t("EMISSION_FACTOR_METHOD_DESC")}
          />
          {shouldShowTable && (
            <TableLoadingWrapper
              tableId={`prod-travel-manual-${productId}`}
              minLoadTime={3000}
              maxLoadTime={20000}
              className="manual-table-wrapper"
            >
              <ProdTravelTable
                productId={productId}
                method="manual"
                key={`manual-${productId}`}
              />
            </TableLoadingWrapper>
          )}
          <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
        </div>
      )}
    </div>
  );
};

export default ProdTravelContents;
